export default {
  API_BASE_URL: 'https://mercury.ecs.stg9.eu-west-1.mvfglobal.net',
  AUTH0_DOMAIN: 'auth-stg.mvfglobal.com',
  AUTH0_AUDIENCE: 'https://mercury.ecs.stg7.eu-west-1.mvfglobal.net',
  AUTH0_CLIENT_ID: 'hZ8H7YKmSBqMupgUFVJ27DmtAfeS7qRO',
  LOG_ROCKET_ENABLED: true,
};
